import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-check-points',
  templateUrl: './check-points.component.html',
  styleUrls: ['./check-points.component.css']
})
export class CheckPointsComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(1669, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    public grid?: GridOptions;

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_checkpointsComponentGrid')
                .setLoadDataFunction({
                    method: 3318,
                    parameters: {
                        argtype: this.setting!.argtype,
                        argvalue: this.setting!.argvalue
                    }
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    page_heading: string;
    argtype: string;
    argvalue: string;
}
